const _ = require('lib/underscore')
const $ = require('lib/jquery')
const BaseModel = require('lib/base_model')
const DetectMobile = require('lib/detect_mobile')
const Modernizr = require('vendor/modernizr')
const log = require('log').create('browser')


const devices = [
    'mobile',
    'iphone',
    'ipad',
    'ios',
    'ios-safari',
    'android',
    'touch',
    'windows',
    'ie11',
]

const Browser = BaseModel.extend({

    defaults: {
        'mac': false,
        'mobile': null,
        'iphone': null,
        'ipad': null,
        'ios': null,
        'ios-safari': null,
        'android': null,
        'touch': null,
        'windows': null,
        'ie11': null,
    },

    initialize(attributes, options) {
        BaseModel.prototype.initialize.apply(this, arguments)

        this.initializeConstants(navigator)
        this.setBrowserClasses()
        this.adjustScaleForTouch()
    },

    onEvent(name) {
        log('browser event:', name)
    },

    initializeConstants(navigator) {
        const ua = navigator.userAgent
        const platform = navigator.platform
        // these properties of the browser don't change
        // so we can calculate and set them once
        const mac = platform.match(/Mac/) // MacIntel
        const iphone = ua.match(/iPhone/i) || ua.match(/iPod/i)
        const ipad = ua.match(/iPad/i)
        const ios = iphone || ipad
        const webkit = ua.match(/WebKit/i)
        // iphone or ipad, webkit (not mozilla), and not one of the known others
        const ios_safari = (iphone || ipad) && webkit && ! ua.match(/CriOS|FxiOS|OPiOS|mercury/i)
        const android = ua.match(/android/i)
        const windows = platform.match(/Win/i) // Win32
        const phantomjs = ua.match(/PhantomJS/i)
        const touch = Modernizr.touchevents && ! phantomjs
        // last of the ie's
        const ie11 = windows && (ua.match(/rv:11\.0/i) || ua.match(/MSIE 11/i))

        const mobile = DetectMobile.isMobile()

        // using !! to coerce booleans
        this.set({
            'mac': !! mac,
            'iphone': !! iphone,
            'ipad': !! ipad,
            'ios': !! ios,
            'ios-safari': !! ios_safari,
            'android': !! android,
            'windows': !! windows,
            'touch': !! touch,
            'mobile': !! mobile,
            'phantomjs': !! phantomjs,
            'ie11': !! ie11,
        })
    },

    setBrowserClasses() {
        const device_classnames = []
        _.each(devices, (type) => {
            if (this.is(type)) {
                device_classnames.push(`browser-${type}`)
            }
        }, this)
        // log('devices', device_classnames)
        $.html.addClass(device_classnames.join(' '))
    },

    adjustScaleForTouch() {
        if (! document.querySelector) return
        if (! document.addEventListener) return

        const viewport_meta = document.querySelector('meta[name="viewport"]')
        const user_agent = navigator.userAgent

        if (! viewport_meta) return

        if (/iPhone|iPad/.test(user_agent) && ! /Opera Mini/.test(user_agent)) {
            viewport_meta.content = 'width=device-width, minimum-scale=1.0, maximum-scale=1.0'
            document.addEventListener('gesturestart', () => {
                viewport_meta.content = 'width=device-width, minimum-scale=0.25, maximum-scale=1.6'
            }, false)
        }

    },

    // overriding model.destroy cuz we don't need typical model.destroy behavior
    // since this model is never part of a collection
    // we just want to remove our listeners and stuff
    destroy() {
        $.window.off(`.${this.cid}`)
        $.body.off(`.${this.cid}`)
    },

})

module.exports = Browser
